// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6ab9429edab7e511","4095":"f175e82cf6773c1f","4985":"f175e82cf6773c1f","5735":"f175e82cf6773c1f"}[chunkId] + ".css";
};